import { httpClient } from 'shared/lib'
import { AxiosError, isAxiosError } from 'axios'
import consoleMessage from 'shared/utils/helpers/consoleMessage'
import { FavouriteProducersResponse } from './types'

export function fetchFavouriteProducers(locationUuid: string, categoryUuid: string) {
   let errMessage = ''

   return httpClient
      .get<FavouriteProducersResponse>(`location/${locationUuid}/categories/${categoryUuid}/producers`)
      .then((res) => {
         if (res.data) {
            return res.data
         }
         throw new Error('No data in request')
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage =
               `status: ${error.response?.status},url: ${error.response?.config.url}, message:${error.response?.data?.errors[0].defaultMessage}` ||
               'Unexpected error'
         } else {
            errMessage = error.message
         }
         consoleMessage('Favourite producers fetchFavouriteProducers service', errMessage, 'error')
         throw new Error(errMessage)
      })
}

export function editFavouriteProducers(
   locationUuid: string,
   categoryUuid: string,
   payload: FavouriteProducersResponse
) {
   let errMessage = ''

   return httpClient
      .put<Result>(`location/${locationUuid}/categories/${categoryUuid}/producers`, {
         ...payload,
      })
      .then((res) => {
         return {
            status: res.status,
         }
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('Favourite producers editFavouriteProducers service', errMessage, 'error')
         throw error
      })
}

export function copyFavouriteProducers(locationUuid: string, categoryUuid?: string) {
   let errMessage = ''

   return httpClient
      .post<Result>(
         categoryUuid
            ? `location/${locationUuid}/categories/${categoryUuid}/producers/overwrite`
            : `location/${locationUuid}/categories/producers/overwrite`
      )
      .then((res) => {
         return {
            status: res.status,
         }
      })
      .catch((error: Error | AxiosError<ErrorType>) => {
         if (isAxiosError<ErrorType>(error)) {
            errMessage = error.response?.data?.errors[0].defaultMessage || ''
         } else {
            errMessage = error.message
         }
         consoleMessage('Favourite producers copyFavouriteProducers service', errMessage, 'error')
         throw error
      })
}
